import React from 'react';
import IconButton from 'material-ui/IconButton';
import {
    Area,
    AreaChart,
    Bar,
    BarChart,
    Cell,
    Line,
    LineChart,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis
} from 'recharts';

import MonthlyRevenue from 'components/dashboard/default/MonthlyRevenue';
import {chartDataWithoutAxis, data2} from 'app/routes/dashboard/routes/ECommerce/data'
import {
    connections, data1, expanseData,
    todoData
} from 'app/routes/dashboard/routes/data'
import ReportBox from 'components/ReportBox/index';
import InfoCard from 'components/InfoCard';
import SimpleToDo from 'components/ToDoCard/index';
import SiteVisitor from 'components/dashboard/Common/SiteVisitor';
import CardBox from 'components/CardBox';
import UserDetailTable from 'components/dashboard/Common/UserDetailTable';
import UserProfileCard from 'components/dashboard/Common/userProfileCard/UserProfileCard';
import MarketingTable from 'components/dashboard/Common/MarketingTable';
import PhotoCollage from 'components/dashboard/Common/PhotoCollage/index';
import LatestNotifications from 'components/dashboard/Common/LatestNotifications';
import RecentActivities from 'components/dashboard/Common/RecentActivities/index';
import {dailyFeedData, projects, recentList} from 'app/routes/dashboard/routes/Intranet/data';
import ProjectsList from 'components/dashboard/Common/ProjectsList';
import YourDailyFeed from 'components/dashboard/Common/DailyFeed/index';
import TimerView from 'components/dashboard/Common/TimerView/index';
import SimpleMap from 'app/routes/map/routes/simple/Components/SimpleMap';
import ContactCard from 'components/Cards/Contact';
import SimpleCard from 'components/Cards/Sample/index';
import PopularProduct from 'components/dashboard/Common/PopularProduct';
import WeatherDetail from 'components/Weather/WeatherDetail';
import LatestPosts from 'components/dashboard/Common/LatestPosts/index';
import Button from 'material-ui/Button';
import CafeCard from 'components/Cards/Cafe/index';
import Statistics from 'components/dashboard/default/Statistics';
import ContainerHeader from 'components/ContainerHeader/index';
import CardMenu from 'components/dashboard/Common/CardMenu';
import Team from 'app/routes/extraPages/routes/aboutUs/Componets/Team';
import CardHeader from 'components/dashboard/Common/CardHeader/index';
import MonthlyReportLineChart from './Components/MonthlyReportLineChart';
import BestSellingMonthBarChart from './Components/BestSellingMonthBarChart';

import {getData_retData} from 'engine/dataServices';

import Coins from 'assets/Images/SwiftImageIcons/Colored/1x/Coins.png';
import CoinStack from 'assets/Images/SwiftImageIcons/Colored/1x/Coinstack.png';
import Coinincrease from 'assets/Images/SwiftImageIcons/Colored/1x/Coinincrease.png';
import DollarStats from 'assets/Images/SwiftImageIcons/Colored/1x/Dollarstats.png';
import DollarBagC from 'assets/Images/SwiftImageIcons/Colored/1x/Dollarbag.png';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

class Default extends React.Component {
    onOptionMenuSelect = event => {
        this.setState({menuState: true, anchorEl: event.currentTarget});
    };
    handleRequestClose = () => {
        this.setState({menuState: false});
    };

    constructor(props) {
        super(props);

        this.props.handleLoading(true);

        this.state = {
            anchorEl: undefined,
            menuState: false,
            cardsData: '',
            last7DayPriceData: '',
            last7DayCountData: '',
            last30DayCountData: '',
            totalCountData: ''
        }

        this.loadData();
    }


    async loadData() {
        var response = await getData_retData('/api/Transaction/GetDetailsForDashboard?developerId=7');
        this.props.handleLoading(false);
        this.setState({cardsData: response[0][0], last7DayPriceData: response[1], last7DayCountData: response[2], last30DayCountData: response[3], totalCountData: response[4]});
    }


    render() {
        const {anchorEl, menuState} = this.state;

        let toDayCountCard = {
            img: Coins,
            title: 'روز جاری',
            subTitle: (this.state.cardsData.ToDay) ? this.state.cardsData.ToDay : '...',
        };
        const yesterdayCountCard = {
            img: CoinStack,
            title: 'روز گذشته',
            subTitle: (this.state.cardsData.Yesterday) ? this.state.cardsData.Yesterday : '...',
        };
        const last7DayCountCard = {
            img: Coinincrease,
            title: 'هفت روز گذشته',
            subTitle: (this.state.cardsData.Last7Day) ? this.state.cardsData.Last7Day : '...',
        };
        const last30DayCountCard = {
            img: DollarBagC,
            title: 'یک ماه گذشته',
            subTitle: (this.state.cardsData.Last30Day) ? this.state.cardsData.Last30Day : '...',
        };
        const sumPriceCountCard = {
            img: DollarStats,
            title: 'کل درآمد کسب شده',
            subTitle: ((this.state.cardsData.SumPrice) ? this.state.cardsData.SumPrice.toLocaleString() : '...') + ' تومان',
        };

        const last7DayPieChart = [];

        if (this.state.last7DayCountData) {
            for (let i = 0; i < this.state.last7DayCountData.length; i++) {
                let item = this.state.last7DayCountData[i];
                last7DayPieChart.push({name: item.InApp_Title, amt: item.Count});
            }
        }

        const last30DayPieChart = [];

        if (this.state.last30DayCountData) {
            for (let i = 0; i < this.state.last30DayCountData.length; i++) {
                let item = this.state.last30DayCountData[i];
                last30DayPieChart.push({name: item.InApp_Title, amt: item.Count});
            }
        }

        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">

                <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={toDayCountCard} styleName="bg-cyan darken-12 text-right"/>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={yesterdayCountCard} styleName="bg-secondary darken- text-right"/>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={last7DayCountCard} styleName="bg-primary text-right"/>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={last30DayCountCard} styleName="bg-red darken-1 text-right"/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-8 col-12">
                        <div className="row">
                            <div className="col-lg-12">
                                <CardBox heading="نمودار فروش">
                                    <MonthlyReportLineChart data={this.state.last7DayPriceData}/>
                                </CardBox>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="jr-card">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <h3 className="card-heading">
                                                پر فروش های 7 روز اخیر
                                            </h3>
                                            <ResponsiveContainer className="mb-4 mb-sm-1 unset-position" height={130}>
                                                <PieChart>
                                                    <Pie dataKey="amt"
                                                         data={last7DayPieChart} cx="50%" cy="50%"
                                                         innerRadius={40}
                                                         outerRadius={60}
                                                         fill="#3367d6"
                                                         paddingAngle={5}
                                                    >
                                                        {
                                                            last7DayPieChart.map((entry, index) => <Cell key={index}
                                                                                                     fill={COLORS[index % COLORS.length]}/>)
                                                        }
                                                    </Pie>
                                                    <Tooltip/>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="jr-card">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <h3 className="card-heading">
                                                پر فروش های 30 روز اخیر
                                            </h3>
                                            <ResponsiveContainer className="mb-4 mb-sm-1 unset-position" height={130}>
                                                <PieChart>
                                                    <Pie dataKey="amt"
                                                         data={last30DayPieChart} cx="50%" cy="50%"
                                                         innerRadius={40}
                                                         outerRadius={60}
                                                         fill="#3367d6"
                                                         paddingAngle={5}
                                                    >
                                                        {
                                                            last30DayPieChart.map((entry, index) => <Cell key={index}
                                                                                                     fill={COLORS[index % COLORS.length]}/>)
                                                        }
                                                    </Pie>
                                                    <Tooltip/>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 col-12">
                        <div>
                            <InfoCard data={sumPriceCountCard} styleName="text-right bg-teal accent-4 text-white"/>
                        </div>
                        <div className="jr-card">
                            <WeatherDetail/>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <CardBox heading="پر فروش ترین محصولات">
                            <BestSellingMonthBarChart data={this.state.totalCountData}/>
                        </CardBox>
                    </div>
                </div>


            </div>

        );
    }
}

export default Default;



// WEBPACK FOOTER //
// ./app/routes/apall/Dashboard/index.js